import { memberCalls2Url } from '@helpers'

const BASE_URL = 'https://ushop-media.unicity.com/glic2027'

const VIDEO_BASE_URL = BASE_URL
const COVER_BASE_URL = BASE_URL

export interface BannerItem {
    cover: string
    vdo: string
    link: string
    isExternal: boolean
}

interface VideoBannersResponse {
    success: boolean
    data: BannerItem[]
}

/**
 * Convert YouTube watch URL to embed URL
 * e.g. https://www.youtube.com/watch?v=xxx → https://www.youtube-nocookie.com/embed/xxx
 */
export const toYouTubeEmbedUrl = (url: string): string => {
    try {
        const parsed = new URL(url)
        const videoId = parsed.searchParams.get('v') ?? parsed.pathname.split('/').pop()
        return `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&playsinline=1`
    } catch {
        return url
    }
}

export const isYouTubeUrl = (url: string): boolean => /youtube\.com|youtu\.be/.test(url)

/**
 * Fetch banners from API
 * API: GET https://member-calls2.unicity.com/unishop-fn-misc/key_value/glic2027_banners
 * Returns array of BannerItem with cover and vdo fields
 */
export const fetchVideoBanners = async (): Promise<BannerItem[]> => {
    const url = memberCalls2Url({ path: '/unishop-fn-misc/key_value/glic2027_banners' })

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })

    if (!response.ok) {
        throw new Error(`Failed to fetch banners: ${response.status} ${response.statusText}`)
    }

    const result: VideoBannersResponse = await response.json()

    if (!result.success || !result.data) {
        throw new Error('Invalid banners response')
    }

    return result.data.map(item => ({
        cover: item.cover ? (item.cover.startsWith('http') ? item.cover : `${COVER_BASE_URL}/${item.cover}`) : '',
        vdo: item.vdo ? (item.vdo.startsWith('http') ? item.vdo : `${VIDEO_BASE_URL}/${item.vdo}`) : '',
        link: item.link ?? '',
        isExternal: item.isExternal ?? false
    }))
}
